import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { NavigatePaths } from '@core/paths';
import { SessionStorageService } from '@core/services/session-storage.service';
import { NavigationHelper } from '@shared/helpers/navigation.helper';

import { AuthService } from '../services/auth.service';

export const AnonymousUserGuard: CanActivateFn = (): boolean => {
  const authService: AuthService = inject(AuthService);
  const storage: SessionStorageService = inject(SessionStorageService);
  const navigate = inject(NavigationHelper);

  const permissions = storage.get('permissions');

  if (authService.isAuthenticated && permissions && permissions.length) {
    navigate.navigateByRoute(NavigatePaths.Accounts.list);
    return false;
  }
  return true;
};
